module.exports = __webpack_public_path__ + "static/media/jpg.a28ad66b.svg";